"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _chart = _interopRequireDefault(require("chart.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default2 = exports.default = {
  name: 'BarChart',
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      handler: function handler() {
        if (this.chartData && this.chartData.labels) {
          this.updateChart();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    if (this.chartData && this.chartData.labels) {
      this.createChart();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    createChart: function createChart() {
      if (!this.chartData || !this.chartData.labels) return;
      var ctx = this.$refs.chartCanvas.getContext('2d');
      this.chart = new _chart.default(ctx, {
        type: 'bar',
        data: this.chartData,
        options: this.options
      });
    },
    updateChart: function updateChart() {
      if (this.chart && this.chartData && this.chartData.labels) {
        this.chart.data = this.chartData;
        this.chart.update();
      } else if (!this.chart && this.chartData && this.chartData.labels) {
        this.createChart();
      }
    }
  }
};